module.exports = __webpack_public_path__ + "static/media/noun_message_160429.19d476ad.svg";